import { ChangeDetectorRef, Component, ElementRef, HostListener, OnInit, ViewChild, inject } from "@angular/core";
import { LoginWidgetService } from "../services/login-widget.service";
import { ActivatedRoute } from "@angular/router";
import { WidgetOptions } from "@okta/okta-signin-widget";
import { Title } from "@angular/platform-browser";
import Keyboard from 'simple-keyboard';
import { IdmUtilities } from '@platform-idm/sdk-javascript';
import { AppearanceService } from "../services/appearance.service";
import { VirtualKeyboardService } from "./VirtualKeyboardService";

@Component({
    selector: 'app-login-base',
    template: '',
  standalone: false,
})

/**Base class to use for login components
 */
export class LoginBase implements OnInit {
  loginWidget: LoginWidgetService;
  route: ActivatedRoute;
  titleService: Title;
  rendered = false;
  showingKeyboard = false;
  keyboardTextEnable = "Enable Digital Keyboard";
  keyboardTextDisable = "Disable Digital Keyboard";
  appearanceService: AppearanceService;

  keyboardText = this.keyboardTextEnable;
  keyboard: Keyboard;
  showKeyboard = false;


  

  toggleKeyboard() {

    this.virtualKeyboard.setEnabled(!this.virtualKeyboard.enabled);
    this.setVirutalKeyboardText();
    return;

  }


  private setVirutalKeyboardText() {
    this.keyboardText = this.virtualKeyboard.enabled ? this.keyboardTextDisable : this.keyboardTextEnable;
  }

  private virtualKeyboard: VirtualKeyboardService;
  constructor() {
    this.virtualKeyboard = inject(VirtualKeyboardService);
    this.loginWidget = inject(LoginWidgetService);
    this.route = inject(ActivatedRoute);
    this.titleService = inject(Title);
    this.appearanceService = inject(AppearanceService);
    this.loginWidget.setVirtualKeyboard(this.virtualKeyboard);
    //if (this.utility.getQueryVariable("showOnscreenKeyboard") == "true") {
    //    this.virtualKeyboard = new VirtualKeyboard();
    //    this.keyboardText = this.virtualKeyboard.enabled ? this.keyboardTextDisable : this.keyboardTextEnable;
    //}
    this.setVirutalKeyboardText();

  }
 
  utility = new IdmUtilities();

 
  ngOnInit(): void {
    let utility = new IdmUtilities();
    this.showKeyboard = utility.getQueryVariable("showOnscreenKeyboard") == "true";
    this.loginWidget.setWidgetOptions(this.getOverrideOptions());
    this.loginWidget.afterRenderCallback = (controller) => {
      this.rendered = true;



      //this controlers renders on page load and when navigsating to page 2
      if (controller == "primary-auth") {
        this.afterRender();

        //primary auth renders 

        if (this.loginWidget.screenNumber == 1)
          this.reportPageChange("page-1");
        if (this.loginWidget.screenNumber == 2)
          this.reportPageChange("page-2");


      }

      //back is handled on clicking back. okta doesnt re-render
      if (controller.indexOf("page-") >= 0) {
        this.reportPageChange(controller);
      }

      this.afterWidgetControllerChanges(controller);

    };

      console.log("rendering widget");
      this.loginWidget.render("widget-container").then((x) => {
        console.log("widget rendered");
        this.hideSpinner();
      }).catch(err => {
        console.error(err);
        this.hideSpinner();
        this.displayError(err);
      });
  }

  /** Override some okta widget options. 
   * 
   * @returns the object with properties/values to override
   * @see https://github.com/okta/okta-signin-widget/blob/master/packages/%40okta/i18n/src/properties/login.properties
   */
  protected getOverrideOptions(): Partial<WidgetOptions> {
    return {};
  }


  /**
* Callback executed after the first page is rendered
* @deprecated use afterPageChanges(1) instead
*/
  protected afterRender() {

  }


  protected afterWidgetControllerChanges(controller: string) {

    }


 

 
  private reportPageChange(controller: string) {
    let pageIndex = controller.indexOf("page-");
    if (pageIndex >= 0) {
        let pageNumber = +controller.substring(5);

      //  if (pageNumber == 1) {
      //      this.listenForUsernameChanges();
      //  }
      //  if (pageNumber == 2) {
      //      this.listenForPasswordChanges();
      //}

      var control = this.loginWidget.currentInputControl;
      //this.setKeyboardValue(pageNumber);

      this.afterPageChanges(pageNumber);
    }
  }

  /**
 * Callback executed after the page changes from 1 to 2 or 2 to 1. Does not fire for other pages handled by the widget
 * @param pageNumber
 */
  protected afterPageChanges(pageNumber: number) {

  }


  protected checkingSession = true;
  protected hideSpinner() {
    this.checkingSession = false;
  }

  @ViewChild("spinner")
  protected spinner?: ElementRef<HTMLDivElement> = undefined;
  protected currentDate = new Date();
  protected copyrightYear = this.currentDate.getFullYear();

  protected displayError(err: any) {
    console.error(err);
    this.error = err;
  }

  protected error = "";

  public addHtmlToFooter(html: string, existingElementsInsertIntoId: string) {


    let authDiv = document.getElementsByClassName("auth-footer");
    let helpLinks = document.getElementsByClassName("link help js-help");

    if (authDiv) {

      let helpLinksContainer = document.getElementById("help-links-container");
      authDiv[0].insertAdjacentHTML('beforeend', html);
      let parent = document.getElementById(existingElementsInsertIntoId);
      //helpLinks[0].remove()
      parent.appendChild(helpLinks[0]);
      console.log(helpLinksContainer);
      parent.appendChild(helpLinksContainer);
    }

  }
}
